export const apiUrl = "https://check.wecheck.ru/api"
